/* ****************************************************************************
 *
 * Ak Kamal e-Security ClientLoader JSLIB v 3.0
 *
 * Для использования, необходимо на странице входа выполнить следующие действия:
 *
 * 1. Подключить JS-библиотеки esscli.js (этот файл), а также dj.js
 *
 * 2. Разместить в любом месте невидимый div с атрибутом id="ak_applet_place"
 *
 * 3. Также на странице вы можете разместить скрытый div (css display:none), который
 * будет автоматически отображаться при загрузке апплета и скрываться, когда он будет
 * загружен. (Пример можно посмотреть на странице https://e-security.kz/onlinedemo/)
 *
 * 4. Разместить кнопку входа с реакция на нажатие - вызов js функции
 * runApplet('', '/?auth=ssl'). runApplet имеет следующие атрибуты:
 *       1 - язык ('kk','ru','en')
 *       2 - uri, куда будет отправлен первый запрос e-Security Client`ом.
 *
 *
******************************************************************************/

function consoleLog(s) {
  try { console.log(s) } catch (e) {}
}

function detectBrowser() {
	console.log(navigator.userAgent);
	var av = navigator.userAgent;
	var isChrome = (av.indexOf("Chrome/") != -1);
	var isSafari = (av.indexOf("Safari/") != -1);
	var isOpera = (av.indexOf("OPR/") != -1);
	var isEdge = (av.indexOf("Edge/") != -1);
	var isFirefox = (av.indexOf("Firefox/") != -1);
	var isTrident = (av.indexOf("Trident/") != -1);
	var isMsIE = (av.indexOf("MSIE ") != -1);

	if (isEdge) {
		return "Edge";
	}

	if (isOpera) {
		return "OPR";
	}

	if (isSafari && !isOpera && !isChrome && !isEdge) {
		return "Safari";
	}

	if (isFirefox) {
		return "Firefox";
	}

	if (isChrome) {
		return "Chrome";
	}

	if (isTrident || isMsIE) {
		return "IE";
	}

	return "UNKNOWN";
}

var mBrowser = detectBrowser();
consoleLog("Browser:"  + mBrowser);

var operaExtId = "jjkkcbaakcfcjladmnhabnfpnjbfbnpm";
var chromeExtId = "nligaijmpjfocilngmacfhfifakkmcgj";

var extId = chromeExtId;
if (mBrowser === "OPR") {
	extId = operaExtId;
}

var isExtInstalled = false;

var ak_ffextmode = false;

var ak_app_sett = Object();

var ak_unsupported = false;

var ak_applet_inserted_flag = false;



function akcr_sendMessage(mess) {
    if (!ak_ffextmode) {
        chrome.runtime.sendMessage(extId, mess,
                function (response) {
                    if (response["command"] != null && response["command"] === "start" && response["status"] === "ok") {
                        akcr_sendMessage({ "command": "disc" });
                        window.location.href = response["url"];
                    }
                }
        );
    } else {
        browser.runtime.sendMessage(mess).then(
            function (response) {
                if (response["command"] != null && response["command"] === "start" && response["status"] === "ok") {
                    akcr_sendMessage({ "command": "disc" });
                    window.location.href = response["url"];
                }
            }
        ,
            function (error) {
                alert("Error:" + JSON.stringify(error));
            }
        );
    }
}

function akcr_checkExtInstalled() {

    if (!ak_ffextmode) {
        if (!chrome.runtime) {
            // под opera, если нет расширение такое встерчается
            isExtInstalled = false;
            return;
        }

        chrome.runtime.sendMessage(extId, {"command": "checkExt"},
            function (response) {
                if (response != null) {
                    isExtInstalled = true;
                }
            }
        );

    } else {

        if (typeof browser === 'undefined' || !browser.runtime) {
            isExtInstalled = false;
            return;
        }

        consoleLog("send checkExt");
        browser.runtime.sendMessage({"command": "checkExt"}).then(
            function(response) {
                if (response != null) {
                    consoleLog("isExtInstalled: true, " + JSON.stringify(response));
                    isExtInstalled = true;
                }
            }
        );
    }
}

var isNeedExt = false;

function ak_preinit(){
	// Check chrome version
	if (mBrowser === "Chrome") {
		var re = new RegExp("Chrome/(\\d+)\\.");
		var vers = re.exec(navigator.appVersion);

		if (vers != null) {
			var chromeVers = vers[1];
			if (chromeVers >= 44) {
				isNeedExt = true;
				akcr_checkExtInstalled();
			}
		}
	}

	// Check opera version
	if (mBrowser === "OPR") {
		var re = new RegExp("OPR/(\\d+)\\.");
		var vers = re.exec(navigator.appVersion);

		if (vers != null) {
			var operaVers = vers[1];
			if (operaVers >= 34) {
				isNeedExt = true;
				akcr_checkExtInstalled();
			}
		}
	}

    // Use webextension mode for firefox from 52 rel
    if (mBrowser === "Firefox") {
        var re = new RegExp("firefox/(\\d+)\\.");
        var vers = re.exec(navigator.userAgent.toLowerCase());

        if (vers != null) {
            if (vers[1] >= 52) {
                ak_ffextmode = true;
                isNeedExt = true;
                akcr_checkExtInstalled();
            }
        }
    }
}

ak_preinit();

function invokeDoIt(lang, message, appletId, minJavaVersion, downloadPage) {

	consoleLog("doIt");

    for (var i = 0; i < document.applets.length; i++) {

        if (document.applets[i].id == appletId) {

            try {

                var curJavaVersion = document.applets[i].getJavaVersion();
                if (!document.applets[i].checkJavaVersion(minJavaVersion)) {
                    alert(message);
                    location.href = downloadPage;
                    return;
                } else {
                    document.applets[i].doIt(lang);
                    return;
                }

            } catch (err) {
				if (console) {
                    consoleLog(err);
				}
            }

        }

    }

    //applet not ready
    setTimeout('invokeDoIt("' + lang + '", "' + message + '", "' + appletId + '", "' + minJavaVersion + '", "' + downloadPage + '")', 100);

}

function runApplet() {
    runApplet("");
}

function runApplet(lang, uri, cert_duration) {

	// Edge пока не поддиржвается
	if (mBrowser === "Edge") {
		if (lang === "en") {
			alert("Edge browser not supported. Use another browser.");
		} else if (lang === "kk") {
			alert("Браузер Edge не поддерживается. Выберите в меню пункт 'Открыть в Internet Expolorer' или воспользуйтесь другим браузером.");
		} else {
			alert("Браузер Edge не поддерживается. Выберите в меню пункт 'Открыть в Internet Expolorer' или воспользуйтесь другим браузером.");
		}
		// Не будем прерывать, а то вдруг ложно срабатывание
		ak_unsupported=true;
		// return;

	}

	// Safari под Windows не поддерживается
	if (navigator.appVersion.indexOf("Win") !=-1 && mBrowser === "Safari") {
		if (lang === "en") {
			alert("Safari on windows systems not supported. Use another browser.");
		} else if (lang === "kk") {
			alert("Браузер Safari на операционной системе windows не поддерживается. Воспользуйтесь другим браузером.");
		} else {
			alert("Браузер Safari на операционной системе windows не поддерживается. Воспользуйтесь другим браузером.");
		}
		ak_unsupported=true;
		// Не будем прерывать, а то вдруг ложно срабатывание
		// return;
	}



    var minJavaVersion = "1.7.0_51";
    var downloadPage = "http://java.com/download/";
    var messOldJava = "Для работы программного обеспечения необходима версия Java " + minJavaVersion + " или выше. Сейчас вы будете перенаправлены на страницу загрузки последней версии Java.";
    var messNoJava = messOldJava;
    if (lang == "en") {
        messOldJava = "The software requires Java v. " + minJavaVersion + " or later. You will be now redirected to download the latest Java version.";
        messNoJava = messOldJava;
    } else if (lang == "kk") {
        messOldJava = "Бағдарламалық қаматаманың жұмысы үшін Java " + minJavaVersion + " немесе одан кеінгі нұсқасы қажет. Сіз Java-ң соңғы нұсқасын жүктеу бетіне сілтеп жіберілесіз.";
        messNoJava = messOldJava;
    }


	if (isNeedExt) {
		if (!isExtInstalled) {
			alert("Вы используете браузер, без поддержки Java. Для работы вам необходимо установить ПО Ak Kamal Web Client Loader. Сейчас вы будете переправлены на страницу с данным программным обеспечением");
			window.location.href = "https://www.e-security.kz/web_loader?brw=" + mBrowser + "&back=" + window.location.href;
			return;
		}
	} else {
		if (deployJava.getJREs().length == 0) {
			alert(messNoJava);
			location.href = downloadPage;
			return;
		}
	}

    /**important_for_local_client**/
    var appletId = "ClientLoader";

    var params = new Array();

	// URL апплета загрузчика - ClientLoader
    var arch = "ClientLoader_TEST_b22.jar";

  // URL до расположения файлов ПО EssClient
  //var url ="https://ib.bcc.kz/applet/1.6.0_274";
  //var url="http://vm1/ib.bcc.kz/applet/1.6.0_275/";
  //var url="http://vm1/ib.bcc.kz/applet/1.7.0_328/";
  //var url="http://vm1/ib.bcc.kz/applet/1.7.0_337/";
  //var url="http://vm1/ib.bcc.kz/applet/1.7.0_340/";
  //var url="http://vm1/ib.bcc.kz/applet/1.7.0_348/";
  //var url="http://vm1/ib.bcc.kz/applet/1.7.0_349/";
  // var url="http://vm1/ib.bcc.kz/applet/1.7.0_364/";
  // var url="https://ib.bcc.kz/applet/1.8.0_369/";
  // var url="https://ib.bcc.kz/applet/1.9.0_390/";
  // var url="https://pzone.akkamal.kz/index.php/s/phRrLC4RNyrW9zw";
  // var url = "https://ib.bcc.kz/applet/1.9.0_400";
  var url = "https://ib.bcc.kz/applet/1.10.0_403/";

  //var url="http://bccuvis/Share/Boha/NSS/SOFT/1.7.0_364/";


	// Доменное имя, к которому осуществляется подключение. Может быть указано несколько через ; (Если указано несколько, то клиент выбирает случайных образом любой)
    //params["proxy.resource"] = "ib1gw1.bcc.kz;ib1gw2.bcc.kz;ib1gw3.bcc.kz";
	params["proxy.resource"] = "business-ess.bcc.kz";
	params["tariff.renew.fromcert"] = "true";

	// Распределение вероятности выбора ресурса из proxy.resource. Например 30;70 (30%-на первый ресурс, 70% - на второй)
    //params["resource.certanly"] = "20;40;40";
	params["resource.certanly"] = "100";
	params["show.create.profile"] = "true";
	// Доменное имя личного кабинета
    params["ecs.reg.host"] = "reg.nss-6.bank.corp.centercredit.kz";

	params["tariff.renew.fromcert"] = "true";
	// URI - на который пойдет первый запрос EssClient
    params["start.uri"] = "/";

	// URI при POST-запросе на который произойдет закрытие сессии пользователя
    params["logout.uri"] = "/logout";

	// URI при POST-запросе на который произойдет выход из клиента
    params["exit.uri"] = "/exit_ess";

	// URL, на который будет переправлен браузер при выходе или закрытии сессии клиента
    params["logoutexit.redirect.url"] = "https://business-test.bcc.kz";

	// URL, с которых разрешено отправлять запросы клиенту
	params["check.referer"] = "false";

	// Имя директории, в которую будет установлено ПО EssClient в домашней директории пользователя
    var folder = "BCC.IB.DBP";


	// Значение других параметров необходимо смотреть в документации
	var f0_url="/i/ib/splash.jpg";
	var f1_url="/i/tray_prox.gif";
	var f2_url="/i/tray.gif";
    var splash_file_name = "splash.jpg";

    var proxy_port = 4200;

    if (uri) {
        params["start.uri"] = uri;
    } else {
        params["start.uri"] = "/";
    }

    params["cache.pass"] = "10000";
    params["cache.ask"] = "false";

    params["proxy.port.end"] = "4487";
    params["proxy.cabport"] = "4488";
    params["proxy.cabport.end"] = "4528";

    params["ru.label.browser"] = "Вход в Cистему Интернет-Банкинга";
    params["ru.tray.tooltip"] = "Вход в Cистему Интернет-Банкинга";
    params["ru.app.name"] = "Система Интернет-Банкинга"

	params["kz.label.browser"] = "Интернет-Банкинг Жүйесіне кіру";
	params["kz.tray.tooltip"] = "Интернет-Банкинг Жүйесіне кіру";
	params["kz.app.name"]="Интернет-Банкинг Жүйесі"

	params["en.label.browser"] = "Login to Internet-Banking System";
	params["en.tray.tooltip"] = "Login to Internet-Banking System";
	params["en.app.name"] = "Internet-Banking System"

	params["ru.error.nce.filter.password"] = "Пароль должен быть длиною от 8 до 32 символов и содержать латинские буквы и цифры";
	params["en.error.nce.filter.password"] = "The password must be between 8 and 32 characters long and contain letters and numbers";
	params["kz.error.nce.filter.password"] = "Құпиясөзде тек латын әриптері мен цифрларын қолдану қажет. Ұзындығы 8 бен 32 белгі арасында болуы керек.";

    params["sign.vis.prefix"] = "title_";

    params["show.cabinet"] = "true";

	params["reconnect.tries"] = "5";
	params["profcache.count"] = "15";
	params["file.pass.policy"] = "^(?=\\S*[A-Za-z])(?=\\S*[0-9])\\S*$";
	params["file.pass.minlen"] = "8";
	params["file.pass.maxlen"] = "32";
	params["armor.on"] = "true";
	params["nocache.exclude.0"] = "image";
	params["nocache.exclude.1"] = "application/x-javascript";
	params["nocache.exclude.2"] = "text/css";
	params["kaztoken.rsakeylen"] = "2048";
    params["remove.cache.headers"] = "off";
	params["connection.timeout"] = "120000";


	params["tariff.name"] = cert_duration == 3 ? "KISC Certificate RK-02-3_new" : "KISC Certificate RK-02-3(GOST+RSA)";
	//	params["tariff.name"] = cert_duration == 3 ? "KISC Certificate RK-02-3_new" : "KISC CERTIFICATE RK02 + RS02 (ГОСТ+RSA)";

    // Ограничим использование APDU-connect устройств для Mac`а, Java крашится там
    if (navigator.appVersion.indexOf("Mac") != -1) {
        params["supported.keystore"] = "file,kaztoken,kaztokenn,aktoken";
    }


    var ps = "proxy.port " + proxy_port + " ";
    for (i in params) {
        ps = ps + i + " '" + params[i] + "' ";
    }
    ps = ps.replace(/(^\s+)|(\s+$)/g, "");


    var attributes = {
        code: 'kz.akkamal.clientloader.Application',
        archive: arch,
        width: 0,
        height: 0,
        id: appletId,
        permissions: 'all-permissions'
    };
    var parameters = {
        url: url,
        folder: folder,
        f0_url: f0_url,
        f1_url: f1_url,
        f2_url: f2_url,
        proxy_port: proxy_port,
        close_on_update: "true",
        splash_file_name: splash_file_name,
        ess_arguments: ps
    };

    /**important_for_local_client**/

	if (isNeedExt) {
		if (isExtInstalled) {
			if (lang != null && lang != "") {
				akcr_sendMessage({"command": "setLang", "arg": lang})
			}

			var obj = {
				command: "start",
				arg: parameters
			};
			akcr_sendMessage(obj);
		}
		return;
	}

    //applet already inserted
    for (var i = 0; i < document.applets.length; i++) {
        if (document.applets[i].id == appletId) {
			if (console) {
				consoleLog("invokeDoIt and return");
			}
            invokeDoIt(lang, messOldJava, appletId, minJavaVersion, downloadPage);
            return;
        }
    }

    var a = document.createElement('applet');
    for (var attribute in attributes) {
        a.setAttribute(attribute, attributes[attribute]);
    }

    for (var parameter in parameters) {
        var p = document.createElement("param");
        p.setAttribute("name", parameter);
        p.setAttribute("value", parameters[parameter]);
        a.appendChild(p);
    }

    ak_app_sett.lang = lang;
    ak_app_sett.messOldJava = messOldJava;
    ak_app_sett.appletId = appletId;
    ak_app_sett.minJavaVersion = minJavaVersion;
    ak_app_sett.downloadPage = downloadPage;


    var applet_tag = '<APPLET id="' + appletId + '" code="kz.akkamal.clientloader.Application" archive="' + arch + '"';
    applet_tag += ' height="0" width="0"';
    applet_tag += ' permissions="all-permissions"';
    applet_tag += '>';
    for (var parameter in parameters) {
        applet_tag+='<PARAM name="' + parameter + '" value="' + parameters[parameter] + '" />';
    }
    applet_tag += '</APPLET>';

    ak_applet_inserted_flag = true;
    document.getElementById("ak_applet_place").innerHTML = applet_tag;
	ak_showHideLoading(true);


    consoleLog("applet appended");
}

function ak_showHideLoading(show) {

	if (ak_unsupported) {
		return;
	}

    var loading_div = document.getElementById('ak_applet_loading');
	if (loading_div) {
		if (show) {
			loading_div.style.display = 'block';
		} else {
			loading_div.style.display = 'none';
		}
	}
}

function ak_applet_inited() {

    if (!ak_applet_inserted_flag) {
        if (console) {
            console.log("ie10 fix. with double applet.start invokation");
        }

        return;
    }

    ak_applet_inserted_flag = false;
	ak_showHideLoading(false);
	if (console) {
		console.log("applet inited");
	}

	setTimeout('invokeDoIt("' + ak_app_sett.lang + '", "' + ak_app_sett.messOldJava + '", "' + ak_app_sett.appletId + '", "' + ak_app_sett.minJavaVersion + '", "' + ak_app_sett.downloadPage + '")', 100);
}
